module.exports = __webpack_public_path__ + "static/media/video-call.89e4d128.svg";